import makeActionCreator from './makeActionCreator';
import {
  FETCH_USER,
  FETCH_USER_DONE,
  FETCH_USER_ERROR,
  FETCH_USER_LOADING,
  FETCH_USER_SUCCESS,
  START_TRIAL,
  START_TRIAL_LOADING,
  START_TRIAL_SUCCESS,
  START_TRIAL_ERROR,
  START_TRIAL_DONE,
} from './actionTypes';

// FETCH USER
export const fetchUser = makeActionCreator(FETCH_USER, 'checkOrgDashboard');
export const fetchUserLoading = makeActionCreator(FETCH_USER_LOADING);
export const fetchUserSuccess = makeActionCreator(FETCH_USER_SUCCESS, 'payload');
export const fetchUserError = makeActionCreator(FETCH_USER_ERROR, 'error');
export const fetchUserDone = makeActionCreator(FETCH_USER_DONE);
export const sessionCheck = fetchUser;

// START TRIAL
export const startTrial = makeActionCreator(START_TRIAL);
export const startTrialLoading = makeActionCreator(START_TRIAL_LOADING);
export const startTrialSuccess = makeActionCreator(START_TRIAL_SUCCESS, 'payload');
export const startTrialError = makeActionCreator(START_TRIAL_ERROR, 'error');
export const startTrialDone = makeActionCreator(START_TRIAL_DONE);
